import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import MetaTable from 'Components/UI/Meta/MetaTable';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(1),
  },
});

const View = ({
  classes, collection, onViewMore,
}) => {
  return (
    <Box className={classes.root}>
      {collection && (
        <MetaTable
          tableMetaOverrideSetName="AccountRequestSummaryTableOverride"
          collection={collection}
          features={{}}
          columns={[
            { name: 'householdId' },
            { name: 'accountTitle', style: { minWidth: '150px' } },
            { name: 'accountId', style: { minWidth: '80px' } },
            { name: 'status', style: { minWidth: '120px' } },
            { name: 'submissionTimestamp', style: { minWidth: '120px' } },
            {
              name: 'View More',
              action: {
                name: 'onViewMore',
              },
              style: { minWidth: '80px' },
            },
          ]}
          actions={{ onViewMore }}
        />
      )}
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object,
  onViewMore: PropTypes.object.isRequired,
};
View.defaultProps = {
  collection: null,
};

export default withStyles(styles)(View);
